import { Badge } from '@/components/ui/badge'

type StatusConfig = {
  label: string
  className: string
}

type StatusBadgeProps = {
  status: string
  config: Record<string, StatusConfig>
  fallback?: StatusConfig
}

export function StatusBadge({ status, config, fallback }: StatusBadgeProps) {
  const statusConfig = config[status] ??
    fallback ?? {
      label: status,
      className: 'bg-muted text-muted-foreground',
    }

  return (
    <Badge variant="outline" className={statusConfig.className}>
      {statusConfig.label}
    </Badge>
  )
}
